import { useEffect } from "react";
import { scrollToId } from "@/lib/scroll";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Products } from "@/components/Products";
import { Manifesto } from "@/components/Manifesto";
import { Gallery } from "@/components/Gallery";
import { Team } from "@/components/Team";
import { Testimonials } from "@/components/Testimonials";
import { Pricing } from "@/components/Pricing";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";
import { ChatWidget } from "@/components/ChatWidget";

export default function Home() {
  useEffect(() => {
    if (window.location.hash === "#quote") {
      setTimeout(() => scrollToId("quote"), 800);
    }
  }, []);
  return (
    <main data-testid="home-page" className="bg-navy-900 text-ice-50 overflow-x-clip">
      <Nav />
      <Hero />
      <Marquee />
      <Services />
      <Products />
      <Manifesto />
      <Gallery />
      <Team />
      <Testimonials />
      <Pricing />
      <QuoteForm />
      <Footer />
      <ChatWidget />
    </main>
  );
}
